import { gql } from '@generated/gql';

const saveForLaterMutation = gql(`
  mutation SendSavedBasket($details: SendSavedBasketInput!) {
    sendSavedBasket(details: $details) {
      token
    }
  }
`);

export { saveForLaterMutation };
